// components/schedule/ScheduleDialog/VehicleSelectionDialog.tsx

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { VehicleSelectionDialogProps } from './types';

export const VehicleSelectionDialog: React.FC<VehicleSelectionDialogProps> = ({
  open,
  onClose,
  cars,
  currentVehicles,
  onCarSelect,
  vehiclesWithOtherSchedules
}) => {
  // 現在選択されている車両IDの配列を取得
  const selectedCarIds = currentVehicles.map(v => v.Car_ID);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableRestoreFocus
    >
      <DialogTitle sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'grey.50',
        px: 3,
        py: 2
      }}>
        車両選択
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={1.5}>
          {cars.map((car) => {
            const isSelected = selectedCarIds.includes(car.ID);
            // 車両の重複チェック - vehiclesWithOtherSchedulesが存在する場合のみチェック
            const hasConflict = vehiclesWithOtherSchedules ? 
              vehiclesWithOtherSchedules.includes(car.ID) : false;

            return (
              <Grid item xs={6} sm={4} key={`car-${car.ID}`}>
                <Button
                  fullWidth
                  variant={isSelected ? "contained" : "outlined"}
                  color={isSelected ? "success" : hasConflict ? "warning" : "primary"}
                  onClick={() => onCarSelect(car)}
                  sx={{
                    height: { xs: '70px', sm: '60px' },
                    minHeight: { xs: '70px', sm: '60px' },
                    p: { xs: 1.5, sm: 1 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    ...(isSelected && {
                      fontWeight: 'bold',
                      boxShadow: 1
                    }),
                    ...(hasConflict && !isSelected && {
                      borderStyle: 'dashed',
                      borderWidth: 2
                    })
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: '0.85rem', sm: '0.875rem' },
                      lineHeight: 1.2,
                      width: '100%',
                      mb: 0.5,
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      whiteSpace: 'normal',
                      // display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {car.Car_Nickname || car.Car_Model}
                    {hasConflict && !isSelected && (
                      <WarningIcon sx={{ ml: 0.5, fontSize: '0.9rem', color: 'warning.main' }} />
                    )}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: '0.7rem', sm: '0.75rem' },
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {car.Car_Number_4}
                  </Typography>
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions sx={{
        borderTop: 1,
        borderColor: 'divider',
        px: 3,
        py: 2
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};